import { CruiseDealPage } from './types';

export const DEAL_DEPARTURE_PAGE_SIZE = 250;

export const INITIAL_FORM_STATE: CruiseDealPage = {
  id: '',
  name: '',
  slug: '',
  heading: '',
  subHeading: '',
  termsAndConditions: '',
  cruiseLine: {
    id: '',
    name: '',
    code: '',
    whiteImageId: null,
  },
  imageId: '',
  startDate: '',
  endDate: '',
  rates: [],
  departures: [],
  availableInBrands: [],
};
